import React, { useState, useEffect } from 'react';
import axios from 'axios';
import './Users.css';

function Users({ user }) {
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedUser, setSelectedUser] = useState(null);
  const [formData, setFormData] = useState({
    purchaseStatus: 'none',
    planLevel: 0,
    expiresAt: ''
  });

  useEffect(() => {
    fetchUsers();
  }, []);

  const fetchUsers = async () => {
    try {
      const response = await axios.get('/api/users');
      setUsers(response.data);
    } catch (error) {
      console.error('Error fetching users:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleUserClick = (user) => {
    setSelectedUser(user);
    setFormData({
      purchaseStatus: user.purchaseStatus || 'none',
      planLevel: user.planLevel || 0,
      expiresAt: user.expiresAt ? new Date(user.expiresAt).toISOString().split('T')[0] : ''
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!selectedUser) return;

    try {
      await axios.put(`/api/users/${selectedUser.id}/purchase`, formData);
      await fetchUsers();
      setSelectedUser(null);
      alert('Статус покупки обновлен');
    } catch (error) {
      console.error('Error updating purchase:', error);
      alert('Ошибка при обновлении статуса покупки');
    }
  };

  const getStatusBadge = (status) => {
    const badges = {
      none: { text: 'Нет покупки', class: 'status-none' },
      pending: { text: 'Ожидает', class: 'status-pending' },
      active: { text: 'Активна', class: 'status-active' },
      expired: { text: 'Истекла', class: 'status-expired' }
    };
    return badges[status] || badges.none;
  };

  const getPlanName = (level) => {
    const plans = {
      0: 'Нет',
      1: 'Базовый',
      2: 'Продвинутый',
      3: 'Максимальный'
    };
    return plans[level] || 'Нет';
  };

  if (loading) {
    return <div className="loading">Загрузка пользователей...</div>;
  }

  return (
    <div className="users">
      <section className="section">
        <div className="container">
          <h1 className="section-title">Управление пользователями</h1>
          <p className="section-subtitle">
            Назначение статуса покупки и тарифных планов
          </p>

          <div className="users-content">
            <div className="users-list">
              <h2 className="users-list-title">Пользователи</h2>
              <div className="users-table">
                <div className="users-table-header">
                  <div className="col-username">Имя</div>
                  <div className="col-status">Статус</div>
                  <div className="col-plan">Тариф</div>
                  <div className="col-date">Дата покупки</div>
                </div>
                {users.map((u) => (
                  <div
                    key={u.id}
                    className={`users-table-row ${selectedUser?.id === u.id ? 'active' : ''}`}
                    onClick={() => handleUserClick(u)}
                  >
                    <div className="col-username">
                      <img src={u.avatar || '/default-avatar.png'} alt={u.username} className="user-avatar-small" />
                      <span>{u.username}</span>
                    </div>
                    <div className="col-status">
                      <span className={`status-badge ${getStatusBadge(u.purchaseStatus).class}`}>
                        {getStatusBadge(u.purchaseStatus).text}
                      </span>
                    </div>
                    <div className="col-plan">{getPlanName(u.planLevel)}</div>
                    <div className="col-date">
                      {u.purchaseDate ? new Date(u.purchaseDate).toLocaleDateString('ru-RU') : '-'}
                    </div>
                  </div>
                ))}
              </div>
            </div>

            {selectedUser && (
              <div className="users-form-panel">
                <h2 className="users-form-title">Редактирование пользователя</h2>
                <div className="user-info">
                  <img src={selectedUser.avatar || '/default-avatar.png'} alt={selectedUser.username} className="user-avatar-large" />
                  <div className="user-details">
                    <div className="user-name">{selectedUser.username}</div>
                    <div className="user-steamid">Steam ID: {selectedUser.steamId}</div>
                  </div>
                </div>

                <form onSubmit={handleSubmit} className="purchase-form">
                  <div className="form-group">
                    <label>Статус покупки</label>
                    <select
                      value={formData.purchaseStatus}
                      onChange={(e) => setFormData({ ...formData, purchaseStatus: e.target.value })}
                      required
                    >
                      <option value="none">Нет покупки</option>
                      <option value="pending">Ожидает</option>
                      <option value="active">Активна</option>
                      <option value="expired">Истекла</option>
                    </select>
                  </div>

                  <div className="form-group">
                    <label>Тарифный план</label>
                    <select
                      value={formData.planLevel}
                      onChange={(e) => setFormData({ ...formData, planLevel: parseInt(e.target.value) })}
                      required
                    >
                      <option value={0}>Нет</option>
                      <option value={1}>Базовый (Уровень 1)</option>
                      <option value={2}>Продвинутый (Уровень 2)</option>
                      <option value={3}>Максимальный (Уровень 3)</option>
                    </select>
                  </div>

                  <div className="form-group">
                    <label>Дата истечения (необязательно)</label>
                    <input
                      type="date"
                      value={formData.expiresAt}
                      onChange={(e) => setFormData({ ...formData, expiresAt: e.target.value })}
                    />
                  </div>

                  <div className="form-actions">
                    <button type="submit" className="btn btn-primary">Сохранить</button>
                    <button type="button" onClick={() => setSelectedUser(null)} className="btn">Отмена</button>
                  </div>
                </form>
              </div>
            )}
          </div>
        </div>
      </section>
    </div>
  );
}

export default Users;

